import axios from "axios";
import environment from "../environment";
import {cookieService} from "./cookie.service";
import {handleAsyncErrors} from "../utils/handleAsyncErrors";
import {customHistory} from "../App";
import {callAPI, USER_TYPE} from "./api-service";

export class formService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  // DEPRECATED
  // async getTaxNumber(svn) {
  //   const cookieToken = await new cookieService().getTokenData();
  //   try {
  //     const response = await axios.get(`${environment.baseUrl}form/taxNumber`, {
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.refreshToken}`,
  //         "app-version": "1.0.1"
  //       },
  //       params: {
  //         svn: svn
  //       }
  //     });
  //     return {
  //       success: true,
  //       data: response.data.taxNumber
  //     };
  //   } catch (e) {
  //     return {
  //       success: false,
  //       message: JSON.parse(e.request.response).message
  //     };
  //   }
  // }

  // DEPRECATED
  async sendForm(data) {
    return {
      success: true
    };
    // eslint-disable-next-line
    const cookieToken = await new cookieService().getTokenData();
    try {
      const response = await axios.post(`${environment.baseUrl}form`, data, {
        headers: {
          Authorization: `Bearer ${cookieToken.refreshToken}`,
          "app-version": "1.0.1"
        }
      });
      if (response) {
        return {
          success: true
        };
      }
    } catch (e) {
      if (!handleAsyncErrors(e.request.status)) {
        return {
          success: false,
          message: JSON.parse(e.request.response).message
        };
      }
    }
  }

  // DEPRECATED
  // async getProtokollStatus(formId, consultantEmail) {
  //   try {
  //     const cookieToken = await new cookieService().getAdminTokenData();

  //     const result = await axios({
  //       method: "Get",
  //       url: `${environment.baseUrl}form/applicationStatus/${formId}/${consultantEmail}`,
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.token}`,
  //         "app-version": "1.0.1"
  //       }
  //     });
  //     //console.log(result);
  //   } catch (err) {
  //     //console.log(err);
  //   }
  // }

  // DEPRECATED
  // async getProtokollDecision(formId, consultantEmail) {
  //   try {
  //     const cookieToken = await new cookieService().getAdminTokenData();

  //     const result = await axios({
  //       method: "Get",
  //       url: `${environment.baseUrl}form/applicationDecision/${formId}/${consultantEmail}`,
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.token}`,
  //         "app-version": "1.0.1"
  //       }
  //     });
  //     //console.log(result);
  //   } catch (err) {
  //     //console.log(err);
  //   }
  // }

  // DEPRECATED
  // async getStripeStatus(formId) {
  //   try {
  //     const cookieToken = await new cookieService().getAdminTokenData();

  //     const result = await axios({
  //       method: "Get",
  //       url: `${environment.baseUrl}form/stripe/${formId}`,
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.token}`,
  //         "app-version": "1.0.1"
  //       }
  //     });
  //     //console.log(result);
  //   } catch (err) {
  //     //console.log(err);
  //   }
  // }

  // DEPRECATED
  // async createStripePayment(formId) {
  //   try {
  //     const cookieToken = await new cookieService().getAdminTokenData();

  //     const result = await axios({
  //       method: "POST",
  //       url: `${environment.baseUrl}form/stripe`,
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.token}`,
  //         "app-version": "1.0.1"
  //       },
  //       data: {
  //         formId: formId
  //       }
  //     });
  //     //console.log(result);
  //     return result;
  //   } catch (err) {
  //     //console.log(err);
  //     return err;
  //   }
  // }

  async updatePOAtermination(requestObj) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/form/updatePoaTermination",
      needsToken: true,
      data: requestObj
    });
    return result.data;
  }

  async updateContractTermination(requestObj) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/form/updateContractTermination",
      needsToken: true,
      data: requestObj
    });
    return result.data;
  }

  // DEPRECATED
  // async getTaxNumberFromFO(formId) {
  //   try {
  //     const cookieToken = await new cookieService().getAdminTokenData();
  //     const result = await axios({
  //       method: "PATCH",
  //       url: `${environment.baseUrl}admin/form/taxNumber/${formId}`,
  //       headers: {
  //         Authorization: `Bearer ${cookieToken.token}`,
  //         "app-version": "1.0.1"
  //       }
  //     });
  //     return result;
  //   } catch (err) {
  //     return err.response.data;
  //   }
  // }

  async downloadZIP(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: `admin/form/download/${formId}`,
      needsToken: true,
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ANV-${formId}.zip`);
    document.body.appendChild(link);
    link.click();
    return {
      success: result.status
    };
  }

  async downloadDecision(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: `admin/form/decision/${formId}`,
      needsToken: true,
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ANV-Decision-${formId}.html`);
    document.body.appendChild(link);
    link.click();
    return {
      success: result.status
    };
  }



  async downloadBescheid(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: `admin/form/bescheid/${formId}`,
      needsToken: true,
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ANV-Bescheid-${formId}.pdf`);
    document.body.appendChild(link);
    link.click();
    return {
      success: result.status
    };
  }

  async getFormDataById(req, admin = false) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: `admin/form/getFormDataByID/${req}`,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getFormProgress(req) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: `admin/form/getFormProgress/${req}`,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getAllForms(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/form",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getBankData(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/form/bankData",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getFoErros(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/form/foErrors",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getAllUsers(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/users",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getChartInfo(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/infoCharts",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getChartFunnel(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/funnelChart",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getChartDevices(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/devicesChart",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getChartAges(params) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/ageChart",
      needsToken: true,
      params: params
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async downloadSupportConversations(req) {
    try {
      const token = await new cookieService().getAdminTokenData();
      const result = await axios({
        method: "GET",
        url: `${environment.baseUrl}support/download?startDate=${req.startDate}&endDate=${req.endDate}`,
        headers: {
          Authorization: "Bearer " + token.token,
          "app-version": "1.0.1"
        },
        responseType: "blob", // important
        data: req
      });
      console.log(result);
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Support-Conversations-${req.startDate.replaceAll(".", "-")}-${req.endDate.replaceAll(".", "-")}.xlsx`);
      document.body.appendChild(link);
      link.click();

      return {
        success: true
      };
    } catch (e) {
      return {
        status: false,
        message: e.toString()
      };
    }
  }

  async downloadTaxConsultantReport(req) {
    try {
      const token = await new cookieService().getAdminTokenData();
      const result = await axios({
        method: "GET",
        url: `${environment.baseUrl}admin/form/consultant/report/${req}`,
        headers: {
          Authorization: "Bearer " + token.token,
          "app-version": "1.0.1"
        },
        responseType: "blob", // important
        data: req
      });
      console.log(result);
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Steuerberater-Report.xlsx");
      document.body.appendChild(link);
      link.click();

      return {
        success: true
      };
    } catch (e) {
      return {
        status: false,
        message: e.toString()
      };
    }
  }

  async getTotalAssignedUnsent() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/totalAssignedUnsent/" + false,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getGroupAssignedUnsent() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/totalAssignedUnsent/" + true,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getFailedSendingForms() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/failedSendingForms/",
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async deleteFailedForm(formId) {
    const result = await callAPI({
      method: "DELETE",
      userType: USER_TYPE.ADMIN,
      endpoint: "admin/statistics/failedSendingForms/" + formId,
      needsToken: true
    });
    return {
      success: result.status,
      data: result.data
    };
  }
}
